import React from 'react';
import { Col, Row, FormGroup, ControlLabel } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { CustomSelect as CustomSelectJs } from '../../../components/CustomControls/CustomSelect';
import { Tooltip as TooltipJs } from '../../../components/Utils/Tooltips';
import { Remove } from '../../../components/Icons/Icons';
import {
    isLaboratorySelectDisabled,
    isProtocolSelectDisabled,
    isClearDisabled,
} from './laboratoryProtocolSelectorRules';

const CustomSelect: any = CustomSelectJs;
const Tooltip: any = TooltipJs;

export interface SelectorOption {
    Value: number | string;
    Name: string;
}

interface LaboratoryProtocolSelectorProps {
    laboratories: SelectorOption[];
    protocols: SelectorOption[];
    laboratoriesLoading: boolean;
    protocolsLoading: boolean;
    selectedLaboratory: SelectorOption | null;
    selectedProtocol: SelectorOption | null;
    onLaboratoryChange: (option: SelectorOption | null) => void;
    onProtocolChange: (option: SelectorOption | null) => void;
    onClear: () => void;
    itemsCount: number;
}

export function LaboratoryProtocolSelector({
    laboratories,
    protocols,
    laboratoriesLoading,
    protocolsLoading,
    selectedLaboratory,
    selectedProtocol,
    onLaboratoryChange,
    onProtocolChange,
    onClear,
    itemsCount,
}: LaboratoryProtocolSelectorProps) {
    const { t } = useTranslation();

    return (
        <div style={{ marginBottom: '2rem' }}>
            <div style={{ display: 'flex', gap: '1rem' }}>
                <Row style={{ width: '100%' }}>
                    <Col sm={6}>
                        <FormGroup>
                            <ControlLabel>{t('commons.laboratories')}</ControlLabel>
                            <CustomSelect
                                name={`select_laboratory`}
                                value={selectedLaboratory}
                                onChange={(_name: string, option: SelectorOption | null) => onLaboratoryChange(option)}
                                options={laboratories}
                                getOptionLabel={(option: SelectorOption | null | undefined) => option?.Name}
                                getOptionValue={(option: SelectorOption | null | undefined) => option?.Value}
                                isDisabled={isLaboratorySelectDisabled({ selectedProtocol })}
                                isLoading={laboratoriesLoading}
                                placeholder={t('commons.select')}
                            />
                        </FormGroup>
                    </Col>
                    <Col sm={6}>
                        <FormGroup>
                            <ControlLabel>{t('commons.protocols')}</ControlLabel>
                            <CustomSelect
                                name={`protocol_select`}
                                value={selectedProtocol}
                                onChange={(_name: string, option: SelectorOption | null) => onProtocolChange(option)}
                                options={protocols}
                                getOptionLabel={(option: SelectorOption | null | undefined) => option?.Name}
                                getOptionValue={(option: SelectorOption | null | undefined) => option?.Value}
                                isDisabled={isProtocolSelectDisabled({ selectedLaboratory, protocolsCount: protocols.length, itemsCount })}
                                isLoading={protocolsLoading}
                                placeholder={t('commons.select')}
                            />
                        </FormGroup>
                    </Col>
                </Row>
                <div style={{ paddingTop: '2.5rem' }}>
                    <button
                        className="btn btn-danger"
                        disabled={isClearDisabled({ selectedLaboratory, selectedProtocol, itemsCount })}
                        onClick={onClear}
                    >
                        <Tooltip tooltip={t('commons.clear')} id={'tooltipedit-limpiaseleccion'}>
                            <span aria-hidden="true"><Remove /></span>
                        </Tooltip>
                    </button>
                </div>
            </div>
        </div>
    );
}
